class StickerColor {

	public id: number;
	public color: string;
	public isDeleted: boolean;

	constructor(id: number, color: string, isDeleted: boolean) {
		this.id = id;
		this.color = color;
		this.isDeleted = isDeleted;
	}

	static fromServer(data: any): StickerColor {
		return new StickerColor(data.id, data.color, data.isDeleted);
	}

}

export default StickerColor;
